import { render, staticRenderFns } from "./utiles-detalles-conversacion.vue?vue&type=template&id=183ce5cd&scoped=true&"
import script from "./utiles-detalles-conversacion.vue?vue&type=script&lang=ts&"
export * from "./utiles-detalles-conversacion.vue?vue&type=script&lang=ts&"
import style0 from "./utiles-detalles-conversacion.vue?vue&type=style&index=0&id=183ce5cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ce5cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VIcon,VList,VListItem,VRow,VSkeletonLoader})
